import React, { useMemo, FC, Fragment, memo, useContext } from "react";
import { useSelector } from "react-redux";
import { IReduxState } from "src/reduxTypes";
import SelectFilter from "../components/SelectFilter";
import DropdownItem from "../../Dropdown/DropdownItem";
import { FiltersContext } from "../context/FiltersProvider";
import { SelectFilterOption, FilterType } from "../types";

const AgencyFilter: FC = () => {
  const { actions } = useContext(FiltersContext);
  const agencies = useSelector(
    (reduxState: IReduxState) => reduxState.auth.agencies
  );
  const options: SelectFilterOption[] = useMemo(
    () =>
      agencies
        .map((agency) => ({
          value: agency.code,
          label: agency.name,
          customValues: {
            country: agency.country,
          },
        }))
        .sort((a, b) =>
          a.customValues.country > b.customValues.country ? 1 : -1
        ),
    [agencies]
  );
  return (
    <SelectFilter
      label="Agency"
      options={options}
      renderOption={(opt) => (
        <Fragment key={`filter-option-${opt.value}`}>
          <DropdownItem
            className="filter-option"
            onClick={() => actions.onSelect(FilterType.AGENCY, opt.value)}
          >
            {opt.label}
            <br />
            <span>{opt.customValues && opt.customValues.country}</span>
          </DropdownItem>
          <DropdownItem divider={true} />
        </Fragment>
      )}
    />
  );
};

export default memo(AgencyFilter);



// WEBPACK FOOTER //
// ./src/share/components/Filters/inputs/AgencyFilter.tsx